"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Done = _interopRequireDefault(require("@material-ui/icons/Done"));

var _Button = _interopRequireDefault(require("../Button"));

var View = function View(_ref) {
  var title = _ref.title,
      onConfirm = _ref.onConfirm,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col items-center justify-center text-center p-8 bg-card",
    style: {
      minWidth: 500
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-20 w-20 flex items-center justify-center border-4 rounded-full text-primary border-primary"
  }, /*#__PURE__*/_react["default"].createElement(_Done["default"], {
    style: {
      fontSize: '3rem'
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-4"
  }, title), /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.map(children, function (node) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-xs text-gray-light mx-auto mt-4 font-bold"
    }, node);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onConfirm,
    className: "w-64"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "button.okayGotIt"
  }))));
};

View.displayName = 'DndConfirmLayout';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=index.js.map